// skipcq: JS-W1028
const COST_CONTROLS_VISIBLE_MODES = new Set(['development', 'staging']);

/**
 * Cost controls are dev/staging operator tools; production Engage hides the panel entirely.
 * @returns {boolean}
 */
export function isCrawlerSchedulerCostControlsVisible() {
  const mode = import.meta.env.MODE;
  if (typeof mode !== 'string' || mode.trim().length === 0) {
    return false;
  }
  return COST_CONTROLS_VISIBLE_MODES.has(mode.trim());
}
